import { ToolboxItem } from "@/components/map-tool-box";
import { CurbZonePageModeType } from "@/modules/curb-zone/curb-zone.type";
import { AddIcon, CurbAreaIcon, EditModeIcon, EditMultiModeIcon, ViewIcon } from "components/icons";
import { EditCurbAreaIcon } from "components/icons/edit-curb-area";

export const curbZoneToolboxIcons: ToolboxItem<CurbZonePageModeType>[] = [
  {
    name: "Curb Zone",
    groups: [
      {
        text: "View",
        mode: CurbZonePageModeType.View,
        icon: <ViewIcon className="h-5 w-5" />,
      },
      {
        text: "Add",
        mode: CurbZonePageModeType.Add,
        icon: <AddIcon className="h-5 w-5" />,
      },
      {
        text: "Edit",
        mode: CurbZonePageModeType.Edit,
        icon: <EditModeIcon className="h-5 w-5" />,
      },
      {
        text: "Multiple Edit",
        mode: CurbZonePageModeType.MultiEdit,
        icon: <EditMultiModeIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Curb Area",
    groups: [
      {
        text: "Add curb area",
        mode: CurbZonePageModeType.AddCurbArea,
        icon: <CurbAreaIcon className="h-5 w-5" />,
      },
      {
        text: "Edit curb area",
        mode: CurbZonePageModeType.EditCurbArea,
        icon: <EditCurbAreaIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Parking Lot",
    groups: [
      {
        text: "Add parking lot",
        mode: CurbZonePageModeType.AddParkingLot,
        icon: <CurbAreaIcon className="h-5 w-5" />,
      },
      {
        text: "Edit parking lot",
        mode: CurbZonePageModeType.EditParkingLot,
        icon: <EditCurbAreaIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Work Area",
    groups: [
      {
        text: "Add work area",
        mode: CurbZonePageModeType.AddWorkArea,
        icon: <CurbAreaIcon className="h-5 w-5" />,
      },
      {
        text: "Edit work area",
        mode: CurbZonePageModeType.EditWorkArea,
        icon: <EditCurbAreaIcon className="h-5 w-5" />,
      },
    ],
  },
];
